import { PerkDefinition } from "./types";

export const perkAdrenaline = {
  id: "perk_adrenaline",
  name: "Adrenaline",
  description: "When you take damage, heal 1 HP.",
  apply: () => {
    // No stat modifications on apply
  },
  onDamageTaken: (_damageAmount, context) => {
    // Heal 1 HP per stack when taking damage
    return context.stackCount * 1;
  },
} satisfies PerkDefinition<"perk_adrenaline">;
